/**
 * Handles the detection of loaded image for Roles and adds the overlay.
 */

const roleImages = [...document.querySelectorAll('.em-role__role-item--background img')];
if (roleImages.length) {
	const hasImageLoad = (img) => {
		img.onload = () => {
			const container = img.closest('.em-role__role-item--background');
			container.classList.add('image-loaded');
		};
	};
	roleImages.map((img) => hasImageLoad(img));
}
